<div class="row rowExpander">
    <div
      class="b-tournament-bracket__zoom"
      style="display: none"
    >
        <button class="btn btn-sm" (click)="zoomIn()" [disabled]="zoomInDisabled">+</button>
        <button class="btn btn-sm" (click)="zoomOut()" [disabled]="zoomOutDisabled">-</button>
    </div>
    <div class="col-12 b-tournament-bracket__wrapper heightAdjuster" #wrapper (mousedown)="mouseDown($event)" (mouseup)="mouseUp($event)" (mousemove)="mouseMove($event)" (mouseleave)="mouseUp($event)">
        <ng-content></ng-content>
    </div>
</div>
